module.exports = __webpack_public_path__ + "img/historical.ad5c66d4.svg";